import {IconNames} from "office-ui-fabric-react";
import {FilingLocation, SharedFile} from "../models";

export class GetIcons {
    static getIcon = (item: FilingLocation, isDarkMode: boolean) => {
        if (item.IsFile) {
            return GetIcons.getIconName(item.Name, isDarkMode, item.Metadata, item.IsFile);
        } else {
            return GetIcons.getFolderIcon(item.Metadata);
        }
    };

    static getSharedIcon = (item: SharedFile, isDarkMode: boolean) => {
        const iconDetails = GetIcons.getIconName(item.FileName, isDarkMode, item.Metadata, true);

        if (item.IsDeleted) {
            iconDetails[1] = "grey";
        }
        return iconDetails;
    };

    static getStandardFolder = () => {
        return [IconNames.FabricFolderFill, "rgb(247,206,101)"];
    };

    static getTabFolder = () => {
        return [IconNames.FolderQuery, "rgb(247,206,101)"];
    };

    

    static getIconName = (name: string, isDarkMode: boolean, metadata: {[key: string]: string}, isFile = false): string[] => {
        if (isFile === false) return GetIcons.getFolderIcon(metadata);

        const ext = name.split(".").reverse()[0].toLowerCase();
        if (ext.startsWith("doc")) {
            return [IconNames.WordDocument, "rgb(34,87,154)"];
        }
        if (ext.startsWith("xls") || ext === "csv") {
            return [IconNames.ExcelDocument, "rgb(33,115,70)"];
        }
        if (ext.startsWith("ppt")) {
            return [IconNames.PowerPointDocument, "rgb(183,71,42)"];
        }
        if (ext.startsWith("pdf")) {
            return [IconNames.PDF, "red"];
        }
        if (ext.startsWith("pub")) {
            return [IconNames.PublisherLogo, "rgb(183,71,42)"];
        }
        if (ext.startsWith("html")) {
            return [IconNames.FileHTML, isDarkMode ? "white" : "black"];
        }
        if (ext === "msg" || ext === "eml") {
            return [IconNames.Mail, "darkyellow"];
        }
        if (ext.startsWith("jp") || ext === "png") {
            return [IconNames.Photo2, isDarkMode ? "white" : "black"];
        }

        return [IconNames.TextDocument, isDarkMode ? "white" : "black"];
    };


    static getFolderIcon = (metadata: {[key: string]: string}) => {
        if (!metadata) {
            return GetIcons.getStandardFolder(); // Handle null or undefined metadata
        }

        return metadata.FolderType === FolderTypeEnum[FolderTypeEnum.Tab]
            ? GetIcons.getTabFolder()
            : GetIcons.getStandardFolder();
    }

}

enum FolderTypeEnum {
    Unknown = 0,
    Regular = 1,
    Tab = 2
  }

export default GetIcons;
